import { createStore } from 'satcheljs';
import getDefaultFilePickerStore from '../utils/getDefaultFilePickerStore';
import type FilePickerStore from './schema/FilePickerStore';

const getFilePickerStore = createStore<FilePickerStore>('filepicker', getDefaultFilePickerStore());
export { getFilePickerStore };
